export function cleanForFirestore(value: any): any {
  if (value instanceof Map) {
    const obj: any = {};
    for (const [k, v] of value.entries()) {
      obj[k] = cleanForFirestore(v);
    }
    return obj;
  } else if (Array.isArray(value)) {
    return value.map(cleanForFirestore);
  } else if (value !== null && typeof value === 'object') {
    const obj: any = {};
    for (const [k, v] of Object.entries(value)) {
      if (v !== undefined) {
        obj[k] = cleanForFirestore(v);
      }
    }
    return obj;
  }
  return value;
}